import Image from "next/image";
export const healthInsurancePoints = [
  {
    description: "Increase in lifestyle-related illnesses",
    image: (
      <div className="w-[50px] h-[50px] relative">
        <Image
          src={"/svgs/get-quote/heart.svg"}
          fill
          style={{ backgroundSize: "cover" }}
          alt="health insurance"
          height={0}
          width={0}
        />
      </div>
    ),
  },
  {
    description: "Group Health Cover is Usually Insufficient",
    image: (
      <div className="w-[50px] h-[50px] relative">
        <Image
          src={"/svgs/get-quote/shield.svg"}
          fill
          style={{ backgroundSize: "cover" }}
          alt="health insurance"
          height={0}
          width={0}
        />
      </div>
    ),
  },
  {
    description: "You Are Covered for More than Just Hospitalization",
    image: (
      <div className="w-[50px] h-[50px] relative">
        <Image
          src={"/svgs/get-quote/report.svg"}
          fill
          style={{ backgroundSize: "cover" }}
          alt="health insurance"
          height={0}
          width={0}
        />
      </div>
    ),
  },
  {
    description: "Inflation is leading to Out of Pocket Expenses Increasing",
    image: (
      <div className="w-[50px] h-[50px] relative">
        <Image
          src={"/svgs/get-quote/rupee.svg"}
          fill
          style={{ backgroundSize: "cover" }}
          alt="health insurance"
          height={0}
          width={0}
        />
      </div>
    ),
  },
];
